// extracted by mini-css-extract-plugin
module.exports = {"root":"aspect-ratio_root__Yh9kR"};